import { Box, Paper, Text } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import { SiestaAction } from '../types';

type Props = {
  action: SiestaAction;
  behindCount: number;
  onExpand: () => void;
};

const BEHIND_COLORS: Record<number, string> = {
  1: 'rgba(119, 47, 23, 1)',
  2: 'rgba(102, 41, 21, 1)',
};

export function StackedCards({ action, behindCount, onExpand }: Props) {
  return (
    <Box w="min(374px, calc(100% - 40px))" pt={behindCount * 8} style={{ overflow: 'visible' }}>
      <Box pos="relative">
        {Array.from({ length: behindCount }).map((_, i) => {
          const depth = behindCount - i;

          return (
            <Paper
              key={`behind-${depth}`}
              radius={24}
              px="md"
              py="sm"
              pos="absolute"
              inset={0}
              bg={BEHIND_COLORS[depth] ?? BEHIND_COLORS[2]}
              style={{
                border: '1px solid rgba(253,253,253,0.15)',
                transform: `translateY(${-depth * 10}px) scale(${1 - depth * 0.1})`,
                transformOrigin: 'center',
                pointerEvents: 'none',
                zIndex: 0,
              }}
            />
          );
        })}
        <Paper
          radius={24}
          px="md"
          py="sm"
          pos="relative"
          onClick={onExpand}
          style={{
            background: 'rgba(0,0,0,0.05)',
            backdropFilter: 'blur(50px)',
            border: '1px solid rgba(253,253,253,0.15)',
            zIndex: 1,
            cursor: 'pointer',
          }}
        >
          <Text size="textXs" fw={FONT_WEIGHTS.bold} c="white">
            {action.label}
          </Text>
        </Paper>
      </Box>
    </Box>
  );
}
